import "./style.scss";
import { useTestimonialWeb } from "./hooks";
import { useElement, useLocale } from "../../../hooks";
import { UserImage } from "../UserImage";
import { useCallback } from "react";
export const TestimonialWeb = () => {
  const { t } = useLocale();
  const Slider = useElement("Slider");
  const { testimonialList } = useTestimonialWeb();
  const renderTestimonialList = useCallback(
    (testimonialFiles) => {
      return testimonialFiles.map((item, index) => {
        return (
          <div className="testimonial" key={index}>
            <UserImage image={JSON.parse(item.image)[0]} name={item.title} />
            <div className="items">
              <h3>{t("testimonialTitle")}</h3>
              <p>{item.content}</p>
              <h5 className="honor-name">{item.name}</h5>
            </div>
          </div>
        );
      });
    },
    [t]
  );

  const setting = {
    rows: 1,
    swipeToSlide: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoPlaySpeed: 3000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {testimonialList.length !== 0 && (
        <div className="pb50 mb60 testimonial-slider">
          <div className="jumbo-container">
            <section className="testimonial">
              <div className="jumbo-container">
                <Slider {...setting}>
                  {renderTestimonialList(testimonialList || [])}
                </Slider>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};
